/** generic data dialog interface */
export * from './byd-generic-dialog-data.interface';

/** bydCanDeactivate interface */
export * from './byd-can-deactivate.interface';
